import { apiClient } from '@/core/api/client';

type ConversationMessage = {
  role: 'user' | 'assistant';
  content: string;
};

type CareStageData = Record<string, unknown> | null;

export type ChatRequestPayload = {
  session_id: string | null;
  status: string;
  user_type: 'advisor' | 'care_seeker';
  message: string;
  confirmed: boolean;
  care_stage_data: CareStageData;
  conversation: ConversationMessage[];
};

/**
 * Maps the authenticated user's role (from useAuth) to the `user_type`
 * value expected by `/care-engine/chat` and `/chat-engine/store-request`.
 */
export const getChatUserType = (role?: string | null): ChatRequestPayload['user_type'] =>
  role === 'FINANCIAL_ADVISOR' ? 'advisor' : 'care_seeker';

type ChatClassification = {
  is_possible?: boolean;
  care_stage?: string;
  care_mode?: string;
  summary?: string;
  zip_code?: string;
  budget_range?: string;
};

export type ChatResponsePayload = {
  session_id: string;
  response: string;
  status: string;
  classification: ChatClassification | null;
  care_stage_data?: CareStageData;
  quick_reply_options?: string | null;
};

/**
 * Sends a chat turn through the bQuest backend BFF proxy (`/care-engine/chat`).
 *
 * The agent URL no longer lives in the browser bundle. The apiClient interceptor
 * attaches the logged-in Bearer token or the guest session token automatically.
 */
export const sendChatMessage = async (
  payload: ChatRequestPayload,
): Promise<ChatResponsePayload> => {
  const { data } = await apiClient.post<ChatResponsePayload>('/care-engine/chat', payload);
  return data;
};
